// セルの高さを要求された高さと既存の高さを比較して計算する。基本的にはどちらか大きい方の高さを返す。
export const calcCellHeight = (newHeight: number | undefined, oldHeight: number | undefined): number => {
  if (newHeight === undefined) {
    return oldHeight ?? 1
  }
  if (oldHeight === undefined) {
    return newHeight
  }
  return Math.max(newHeight, oldHeight)
}
